import React from "react";
import {
  Avatar,
  Badge,
  Box,
  Button,
  Card,
  Grid,
  Group,
  Stack,
  Text,
  Divider,
  useMantineTheme,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { Star, FileDescription, Checklist, UserPlus } from "tabler-icons-react";
import { useQueryClient } from "@tanstack/react-query";
import { useGetOrg } from "api/organizations/getOrg";
import { useUser } from "hooks/useUser";

export default function EmployeeGrid(): JSX.Element {
  const { user } = useUser();
  const { data: org, isLoading, isError } = useGetOrg(user.org?._id);
  const theme = useMantineTheme();
  const isSmall = useMediaQuery(`(max-width: ${theme.breakpoints.sm}px)`);

  if (isLoading) return <Text>Loading...</Text>;
  if (isError || !org?.members) return <Text>Error loading members</Text>;

  return (
    <Box>
      <Grid gutter="md">
        {org.members.map((emp) => {
          const fullName = `${emp.firstName} ${emp.lastName}`;
          const key = emp._id;
          return (
            <Grid.Col key={key} xs={12} sm={12} md={6} lg={6}>
              <Card
                shadow="xl"
                radius="md"
                withBorder
                style={{ height: "100%" }}
              >
                <Group noWrap spacing={0} style={{ height: "100%" }}>
                  <Box
                    style={{
                      width: "30%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <Avatar
                      // src={emp.avatar || undefined}
                      size={isSmall ? 80 : 100}
                      radius="xl"
                      sx={{
                        boxShadow: theme.shadows.md,
                        marginBottom: theme.spacing.sm,
                      }}
                    />

                    <Stack
                      spacing={8}
                      style={{ display: "flex", flexDirection: "row" }}
                    >
                      <Group spacing={6}>
                        <Checklist size={20} color={theme.colors.gray[6]} />
                        <Text size="sm" weight={500}>
                          {/* {String(emp.taskCount ?? 0).padStart(2, "0")} */}
                        </Text>
                      </Group>
                      <Group spacing={6}>
                        <Star size={20} color={theme.colors.yellow[6]} />
                        <Text size="sm" weight={500}>
                          {/* {emp.rating ?? "--"} */}
                        </Text>
                      </Group>
                      <Group spacing={6}>
                        <FileDescription
                          size={20}
                          color={theme.colors.red[6]}
                        />
                        <Text size="sm" weight={500}>
                          {/* {String(emp.reportCount ?? 0).padStart(2, "0")} */}
                        </Text>
                      </Group>
                    </Stack>
                  </Box>

                  <Divider orientation="vertical" mx="sm" />

                  <Box
                    px="md"
                    py="md"
                    sx={{ flex: 1, display: "flex", flexDirection: "column" }}
                  >
                    <Group
                      style={{
                        flexDirection: "column",
                        display: "flex",
                        alignItems: "flex-start",
                      }}
                    >
                      <Text weight={600} size={isSmall ? "md" : "lg"}>
                        {fullName}
                      </Text>
                      <Badge
                        color="grape"
                        variant="light"
                        sx={{
                          backgroundColor: "#cac2ecff",
                          color: "black",
                          padding: "10px",
                        }}
                      >
                        {emp.position}
                      </Badge>
                    </Group>

                    <Divider my="sm" />

                    <Text size="sm" color="gray" sx={{ flex: 1 }}>
                      {emp.role}
                    </Text>

                    <Group mt="auto" spacing="sm">
                      <Button
                        leftIcon={<UserPlus size={16} />}
                        size={isSmall ? "xs" : "sm"}
                        variant="filled"
                      >
                        Add Task
                      </Button>
                      <Button
                        leftIcon={<FileDescription size={16} />}
                        size={isSmall ? "xs" : "sm"}
                      >
                        Profile
                      </Button>
                    </Group>
                  </Box>
                </Group>
              </Card>
            </Grid.Col>
          );
        })}
      </Grid>
    </Box>
  );
}
